export default "__VITE_ASSET__BuGn0mNG__"